import BaseComponent from './BaseComponent.js'
import { diamond, diamondBlock, diamondBlockStack, goldIngot } from '../assets/mc.js'

export default class CozyPrice extends BaseComponent {
  static get is() { return 'price' }

  get styles() {
    return `
      :host span {
        cursor: default;
        font-weight: bold;
        display: inline-flex;
        align-items: center;
        white-space: preserve nowrap;
        font-family: monospace;
      }
      :host i {
        opacity: 0.7;
        font-weight: normal;
        margin-right: 0.1em;
      }
      :host img {
        height: 1.5em;
        margin-right: 0.1em;
      }
    `
  }

  get currencyType() {
    return this.params[0] || ''
  }

  get currencyText() {
    switch (this.currencyType) {
      case 'di':
        return 'Diamonds'
      case 'db':
        return 'Diamond Blocks'
      case 'dbs':
        return 'Stack of Diamond Blocks'
      case 'gi':
        return 'Gold Ingots'
      default:
        return '?'
    }
  }

  get currencyImage() {
    switch (this.currencyType) {
      case 'di':
        return diamond
      case 'db':
        return diamondBlock
      case 'dbs':
        return diamondBlockStack
      case 'gi':
        return goldIngot
      default:
        return this.currencyType ? '' : '?'
    }
  }

  get values() {
    let min = 0
    let max = 0
    let amount = (this.params[1] || '0')
    if (amount.includes(',')) {
      const [minStr, maxStr] = amount.split(',').map(a => a.trim())
      min = parseFloat(minStr) || 0
      max = parseFloat(maxStr) || 0
    } else {
      min = parseFloat(amount) || 0
      max = min
    }
    let avg = this.params[2] || 0
    if (!avg) {
      avg = ((min + max) / 2)
    } else avg = parseFloat(avg)
    //.split(',').map(a => a.trim()).join(' - ')
    return { min, max, avg }
  }

  #formatPrice(value, decimals = 0) {
    // return value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
    // return String(value.toFixed(decimals)).padStart(2, '0')
    const s = String(value.toFixed(decimals))
    if (s.length < 2) return ` ${s}`
    return s
  }

  updated() {
    const params = this.params
    if (params.length < 1) {
      this.componentText = 'Invalid price'
      return
    }
    // @TODO: Generate tooltip with table with changes (if any) minimum, maximum, average (if not provided then calculate from min/max)

    const { min, max, avg } = this.values
    const prefix = min === max ? ' ' : '~'
    this.componentHtml = `${prefix}${this.#formatPrice(avg)}<i>×</i> ${this.currencyImage ? `<img part="image" class="image" src="${this.currencyImage}" alt="${this.currencyText}" />` : ''}`
    if (min === max) {
      this.setComponentAttribute('title', `${min} ${this.currencyText}`)
    } else {
      this.setComponentAttribute('title', `Min: ${min}\nMax: ${max}\nAvg: ${avg.toFixed(1)}\n${this.currencyText}`)
    }
  }
}
